import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ClientTypeFields, clientTypeError } from "@/components/ClientTypeFields";
import { JET_CARD_CATEGORIES } from "@/lib/format";
import { useApi, errMsg } from "@/lib/api";

const fromTrip = (t) => ({
  clientType: t.client_type || "",
  program: t.jet_card_program || "",
  jetCategory: JET_CARD_CATEGORIES.some((c) => c.value === t.aircraft_category) ? t.aircraft_category : "",
});

export default function ClientTypeDialog({ trip, open, onOpenChange, onSaved }) {
  const api = useApi();
  const [value, setValue] = useState(fromTrip(trip));
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) { setValue(fromTrip(trip)); }
  }, [open, trip]);

  const save = async () => {
    const err = clientTypeError(value);
    if (err) return toast.error(err);
    const jet = value.clientType === "jet_card";
    setSaving(true);
    try {
      await api.patch(`/trips/${trip.id}`, {
        client_type: value.clientType,
        ...(jet ? { jet_card_program: value.program, aircraft_category: value.jetCategory } : {}),
        notify: false,
      });
      toast.success("Client type updated");
      onOpenChange(false);
      onSaved();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#111319] border-white/10 max-w-2xl w-[calc(100%-2rem)] grid-cols-[minmax(0,1fr)] max-h-[90vh] overflow-y-auto" data-testid="client-type-dialog">
        <DialogHeader>
          <p className="eyebrow">{trip.ref}</p>
          <DialogTitle className="font-serif-display text-3xl font-normal text-white">Edit client type</DialogTitle>
        </DialogHeader>
        <div className="mt-2"><ClientTypeFields value={value} onChange={setValue} /></div>
        <div className="flex flex-wrap justify-end gap-3 pt-4">
          <button type="button" className="frame-btn" onClick={() => onOpenChange(false)} data-testid="client-type-cancel-btn">Cancel</button>
          <button type="button" className="frame-btn gold" disabled={saving} onClick={save} data-testid="client-type-save-btn">{saving ? "Saving…" : "Save"}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
